<template>
  <AntPagination
    v-model="inputVal"
    :total="total"
    :pageSize="6"
    size="small"
    :showTotal="
      (total, range) => `Zeige ${range[0]}-${range[1]} von ${total} Firmen`
    "
  />
</template>

<script>
import AntPagination from 'ant-design-vue/lib/pagination'
import 'ant-design-vue/lib/pagination/style/index.css'

export default {
  components: {
    AntPagination
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.ant-pagination-item) {
  border: none;
  border-radius: 0;
}
:deep(.ant-pagination-item-active),
:deep(.ant-pagination-item:focus),
:deep(.ant-pagination-item:hover) {
  font-weight: 500;
  text-decoration: underline;
  a {
    color: #eb003c;
  }
}
:deep(.ant-pagination-next:hover .ant-pagination-item-link),
:deep(.ant-pagination-prev:hover .ant-pagination-item-link) {
  color: #eb003c;
  border: none;
}
:deep(.ant-pagination-item-link),
:deep(.ant-pagination-item-link:hover),
:deep(.ant-pagination-jump-next)
  .ant-pagination-item-container
  .ant-pagination-item-link-icon {
  color: #eb003c;
  border: none;
}
</style>
